module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/august-a7886d02bafc332c91b8a6c041da909f.png";